<template>
    <div
        class="c_form-item"
        :style="[ parentStyle_ ]"
    >
        <p
            :class="isTable ? 'f_label':''"
            class="form_label"
        >{{ header.title }}</p>
        <p
            v-if="!isTable"
            class="color_9 maohao"
        >:</p>
        <!-- Upload 上传 -->
        <RenderUpload
            v-if="header.type === 'upload'"
            :data="data"
            :header="header"
            :is-table="isTable"
        />
        <!-- CustomUpload 自定义组件上传 -->
        <RenderUploadCustom
            v-else-if="header.type === 'CustomUpload'"
            :data="data"
            :header="header"
        />
        <!-- 其他表单 -->
        <p
            v-else
            class="form_value"
        >{{ data[header.field] }}</p>
    </div>
</template>

<script>
import RenderUpload from './renderUpload.vue'
import RenderUploadCustom from './renderUploadCustom.vue'

export default {
    name: 'RenderForm',
    components: { RenderUpload, RenderUploadCustom },
    mixins: [],
    props: {
        data: {
            type: Object,
            default: null
        },
        header: {
            type: Object,
            default: null
        },
        isTable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },

    computed: {
        parentStyle_() {
            return {
                alignItems: this.isTable ? 'flex-star' : 'center'
            }
        }

    },

    created() {
    },

    methods: {
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.c_form-item {
    width: 100%;
    display: flex;

    .form_label {
        font-size: 16px;
        color: #000;
        flex: 0 0 120px;
        margin-right: 10px;
        text-align: right;
        display: inline-block;
        text-align: justify;
        text-align-last: justify;
        color: #666;
    }

    .form_value {
        margin-left: 30px;
        margin-bottom: 10px;
        line-height: 48px;

        .img_wrap {
            display: flex;
            align-items: center;
        }

        .img {
            margin-right: 10px;
            width: 100px;
            height: 100px;
        }
    }
}
</style>
